var map = {
	"./AboutUs/AboutSection": 5600,
	"./AboutUs/AboutSection.js": 5600,
	"./AboutUs/AboutSectionContent": 9259,
	"./AboutUs/AboutSectionContent.js": 9259,
	"./AboutUs/AboutSectionTwo": 1160,
	"./AboutUs/AboutSectionTwo.js": 1160,
	"./AboutUs/AboutUs": 3399,
	"./AboutUs/AboutUs.js": 3399,
	"./AboutUs/FlavorsList": 983,
	"./AboutUs/FlavorsList.js": 983,
	"./AboutUs/FlavorsList2": 4673,
	"./AboutUs/FlavorsList2.js": 4673,
	"./AboutUs/ThreeImages": 3672,
	"./AboutUs/ThreeImages.js": 3672,
	"./Auth/ConfirmPassword": 2454,
	"./Auth/ConfirmPassword.js": 2454,
	"./Auth/ForgotPassword": 2105,
	"./Auth/ForgotPassword.js": 2105,
	"./Auth/Login": 6418,
	"./Auth/Login.js": 6418,
	"./Auth/MyAccount/AccountDetails": 1222,
	"./Auth/MyAccount/AccountDetails.js": 1222,
	"./Auth/MyAccount/ChangePassword": 4504,
	"./Auth/MyAccount/ChangePassword.js": 4504,
	"./Auth/MyAccount/Layout": 8079,
	"./Auth/MyAccount/Layout.js": 8079,
	"./Auth/MyAccount/MyAccount": 9008,
	"./Auth/MyAccount/MyAccount.js": 9008,
	"./Auth/MyAccount/OrderDetails": 6983,
	"./Auth/MyAccount/OrderDetails.js": 6983,
	"./Auth/MyAccount/Orders": 6624,
	"./Auth/MyAccount/Orders.js": 6624,
	"./Auth/MyAccount/Pay": 2731,
	"./Auth/MyAccount/Pay.js": 2731,
	"./Auth/Register": 4646,
	"./Auth/Register.js": 4646,
	"./Auth/ResetPassword": 3397,
	"./Auth/ResetPassword.js": 3397,
	"./Auth/VerifyEmail": 9728,
	"./Auth/VerifyEmail.js": 9728,
	"./Blog/Author": 274,
	"./Blog/Author.js": 274,
	"./Blog/Image": 512,
	"./Blog/Image.js": 512,
	"./Blog/PhotoAuthor": 4986,
	"./Blog/PhotoAuthor.js": 4986,
	"./Blog/Post": 3527,
	"./Blog/Post.js": 3527,
	"./Blog/PostListItem": 4452,
	"./Blog/PostListItem.js": 4452,
	"./Blog/Posts": 1842,
	"./Blog/Posts.js": 1842,
	"./Checkout/Checkout": 3029,
	"./Checkout/Checkout.js": 3029,
	"./Checkout/Form": 7561,
	"./Checkout/Form.js": 7561,
	"./Checkout/SuccessCheckout": 38,
	"./Checkout/SuccessCheckout.js": 38,
	"./Checkout/TableProductList": 2742,
	"./Checkout/TableProductList.js": 2742,
	"./Checkout/TableTotal": 4395,
	"./Checkout/TableTotal.js": 4395,
	"./Checkout/YourOrder": 2144,
	"./Checkout/YourOrder.js": 2144,
	"./ContactUs/AddressList": 3175,
	"./ContactUs/AddressList.js": 3175,
	"./ContactUs/ContactUs": 2615,
	"./ContactUs/ContactUs.js": 2615,
	"./ContactUs/Form": 1049,
	"./ContactUs/Form.js": 1049,
	"./ContactUs/Map": 5185,
	"./ContactUs/Map.js": 5185,
	"./Dashboard": 5758,
	"./Dashboard.js": 5758,
	"./ErrorPage/ErrorPage": 6119,
	"./ErrorPage/ErrorPage.js": 6119,
	"./Home/Carousel": 2854,
	"./Home/Carousel.js": 2854,
	"./Home/CarouselMenu": 7709,
	"./Home/CarouselMenu.js": 7709,
	"./Home/Home": 8483,
	"./Home/Home.js": 8483,
	"./Home/OneSection": 3443,
	"./Home/OneSection.js": 3443,
	"./Home/TwoSectionContactUs": 5861,
	"./Home/TwoSectionContactUs.js": 5861,
	"./Home/TwoSectionHours": 3938,
	"./Home/TwoSectionHours.js": 3938,
	"./Home/TwoSectionItems": 1905,
	"./Home/TwoSectionItems.js": 1905,
	"./Home/TwoSectionMenu": 5102,
	"./Home/TwoSectionMenu.js": 5102,
	"./Privacy/PrivacyPolicy": 7593,
	"./Privacy/PrivacyPolicy.js": 7593,
	"./Privacy/PrivacySection1": 3105,
	"./Privacy/PrivacySection1.js": 3105,
	"./Product/Description": 7314,
	"./Product/Description.js": 7314,
	"./Product/Feature": 6786,
	"./Product/Feature.js": 6786,
	"./Product/Images": 2300,
	"./Product/Images.js": 2300,
	"./Product/Product": 3867,
	"./Product/Product.js": 3867,
	"./Product/RelatedProducts": 4547,
	"./Product/RelatedProducts.js": 4547,
	"./Product/SelectQuantity": 2431,
	"./Product/SelectQuantity.js": 2431,
	"./Products/Categories": 4197,
	"./Products/Categories.js": 4197,
	"./Products/FollowUs": 3452,
	"./Products/FollowUs.js": 3452,
	"./Products/Layout": 5555,
	"./Products/Layout.js": 5555,
	"./Products/NewProducts": 6335,
	"./Products/NewProducts.js": 6335,
	"./Products/Products": 1425,
	"./Products/Products.js": 1425,
	"./Products/ProductsList": 9301,
	"./Products/ProductsList.js": 9301,
	"./Products/Sidebar": 8545,
	"./Products/Sidebar.js": 8545,
	"./Products/Tags": 5504,
	"./Products/Tags.js": 5504,
	"./ShoppingCart/CartProduct": 3714,
	"./ShoppingCart/CartProduct.js": 3714,
	"./ShoppingCart/CartProductList": 4502,
	"./ShoppingCart/CartProductList.js": 4502,
	"./ShoppingCart/ShoppingCart": 4761,
	"./ShoppingCart/ShoppingCart.js": 4761,
	"./ShoppingCart/SummaryPrice": 7634,
	"./ShoppingCart/SummaryPrice.js": 7634,
	"./Studio/Studio": 4001,
	"./Studio/Studio.js": 4001,
	"./Welcome": 5004,
	"./Welcome.js": 5004
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8846;